require("bijou/widgets/info_box_set");

(function ($) {
  "use strict";
  $.widget("bijou.comparison", $.bijou.base, {
    _create: function () {
      var submitted = false;

      this.element.infoBoxSet();

      this._on({
        infoboxsetshown: function (e, data) {
          data.box.closest("td").addClass("active-info-box");

          var popup = data.box.find(".info-box-content");

          if (!data.box.hasClass("excess")) {
            popup.removeClass("left right");

            if (this._rightEdge(popup) < this._rightEdge(this.element)) {
              popup.addClass("right");
            } else {
              popup.addClass("left");
            }
          }

          this._scrollIntoView(popup);
        },

        infoboxsethidden: function (e, data) {
          data.box.closest("td").removeClass("active-info-box");
        },

        validate: function (e) {
          // validate event is triggered by smart_form just before submission
          if (submitted) e.preventDefault();
          submitted = true;
        },
      });

      this._on(this.document, {
        click: function (e) {
          if (
            $(e.target).closest(".info-box-toggle, .info-box-content")
              .length === 0
          ) {
            this.element.infoBoxSet("hide");
          }
        },
      });
    },

    _scrollIntoView: function (infoBox) {
      var windowHeight = this.window.height(),
        scrollTop = this.window.scrollTop(),
        boxHeight = infoBox.outerHeight(true),
        boxTop = infoBox.offset().top;

      if (boxTop + boxHeight > scrollTop + windowHeight) {
        $("html, body").animate(
          {
            scrollTop:
              scrollTop + (boxHeight - (windowHeight + scrollTop - boxTop)),
          },
          "fast",
        );
      }
    },

    _rightEdge: function (element) {
      return element.outerWidth(true) + element.offset().left;
    },
  });
})(window.jQuery);
